module.exports = __webpack_public_path__ + "static/media/incomplete-circuit.b9e2dd1f.svg";